module.exports = __webpack_public_path__ + "img/google-pay.91b7ea96.svg";